<template>
  <div class="feedback">
    <div id="left-pane">
      <div class="test-details">
        <img id="image" src="../assets/test_submitted.svg" alt="Fill Details" />
        <p id="sample-test">{{ $store.state.test.name }}</p>
        <table rules="rows" class="parent-test-details">
          <tr>
            <td class="test-details-left-column">By</td>
            <td class="test-details-right-column" style="color: #0988f4">
              {{ $store.state.test.companyName }}
            </td>
          </tr>
          <!--<tr>
            <td class="test-details-left-column">Time Taken</td>
            <td class="test-details-right-column">
              {{ $store.getters.getTimeTaken }} mins
            </td>
          </tr>-->
        </table>
      </div>
    </div>
    <div class="right-pane">
      <div class="inner-white-div">
        <div class="test-submit-image">
          <img
            src="../assets/test_submit.svg"
            alt="Test Submitted Successfully"
          />
        </div>
        <div v-if="isSubmitted == true" class="heading">
          You can close this tab now
        </div>
        <div v-else class="feedback-details">
          <div class="heading">Please rate your test experience</div>
          <div v-for="i in 5" :key="i">
            <div class="feedback-questions">
              <div class="question">{{ questions[i - 1] }}</div>
              <div class="stars">
                <StarRating
                  v-model="ratings[i - 1]"
                  :star-size="20"
                  inactive-color="#9EAAC2"
                  active-color="#1BC09C"
                  :padding="8.4"
                  :show-rating="false"
                ></StarRating>
              </div>
            </div>
            <div v-if="i != 5" class="hr"></div>
          </div>
          <div class="comments">
            <textarea
              v-model="comments"
              class="textArea"
              rows="16"
              cols="20"
              :placeholder="'Your Comments here'"
            ></textarea>
          </div>
          <div class="buttons">
            <button class="submit" @click="submitFeedback">SUBMIT</button>
            <button class="skip" @click="submitFeedback">SKIP</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import api from '../services/api.service'
export default {
  name: 'Feedback',
  components: { StarRating },
  data() {
    return {
      questions: [
        'Usability of Code Editor',
        'Fairness of skill assessment',
        'Clarity of questions',
        'Usability of test interface',
        'Ease of use',
      ],
      ratings: [3, 3, 3, 3, 3],
      comments: '',
      isSubmitted: false,
    }
  },
  methods: {
    submitFeedback() {
      var testId = this.$store.state.test.testId
      var userId = this.$store.state.userId
      var feedback = {
        ratings: this.ratings,
        comments: this.comments,
      }
      api.postFeedback(testId, userId, feedback).then(response => {
        console.log(response)
      })
      api.sendSummaryEmail(testId).then(response => {
        console.log(response)
      })
      this.isSubmitted = true
      this.exitFromFullScreen()
    },
    exitFromFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
  },
}
</script>
<style scoped>
.buttons {
  display: flex;
  margin: auto;
  margin-bottom: 220px;
  width: fit-content;
}
.comments {
  margin: 52px auto 27px auto;
  width: fit-content;
}
.feedback-details {
  margin: auto;
  width: fit-content;
}
.textArea {
  outline: none;
  opacity: 0.44;
  background: #ffffff;
  border: 2px solid rgba(155, 155, 155, 0.2);
  resize: vertical;
  width: 350px;
  padding: 10px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #616262;
  box-sizing: border-box;
  cursor: text;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  height: 100px;
}
.textArea:focus {
  border: 1px solid #0988f4;
  opacity: 1;
}
.hr {
  border: 1px solid #f2f2f2;
  margin: 0px 32px;
}
.stars {
  margin-left: 30px;
}
.feedback-questions {
  display: flex;
  margin: 16px 32px;
}
.question {
  font-family: Roboto-Regular;
  font-size: 16px;
  color: #616262;
  letter-spacing: 0;
  line-height: 20px;
  width: 100%;
  text-align: left;
}
.heading {
  font-family: Roboto-Light;
  font-size: 32px;
  color: #616262;
  letter-spacing: 0;
  margin-bottom: 34px;
}
.feedback {
  display: flex;
  margin-top: 64px;
  flex: 1;
  overflow: hidden;
}
.inner-white-div {
  flex: 1;
  margin: 42px;
  background: #ffffff;
  border-radius: 2px;
}
.test-details-right-column {
  font-family: Roboto-Medium;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 16px 0;
}

.test-details-left-column {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 0 32px;
}

.parent-test-details {
  border: none;
  margin-right: 32px;
  width: 346px;
}

.parent-test-details tr {
  border-top: solid thin;
  border-bottom: solid thin;
  border-color: #efeef3;
}
#image {
  margin: 48px auto;
  height: 215px;
  display: block;
  width: 240px;
}
.test-submit-image {
  margin: 32px auto 32px auto;
}
#left-pane {
  background: #ffffff;
  box-shadow: inset -1px 0 0 0 #a8b2c6;
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 376px;
}
#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}
#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}
.right-pane {
  flex: 1;
  text-align: center;
  background: #efeef3;
  color: #69758b;
  overflow: auto;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.submit {
  border: 1px solid #0988f4;
  border-radius: 2px;
  width: 126px;
  height: 40px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #0988f4;
  background-color: white;
  cursor: pointer;
  outline: #0988f4;
  margin-right: 10px;
}
.submit:hover {
  background: #319bf5;
  box-shadow: 0 10px 20px 0 rgba(49, 155, 245, 0.4);
  color: #ffffff;
  -webkit-transition: background-color 0.2s ease-out;
  -moz-transition: background-color 0.2s ease-out;
  -o-transition: background-color 0.2s ease-out;
  transition: background-color 0.2s ease-out;
}
.skip {
  background: #ffffff;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #616262;
  width: 143px;
  height: 40px;
  outline: #1bc09c;
  cursor: pointer;
}

.skip:hover {
  background: #1bc09c;
  box-shadow: 0 10px 20px 0 rgba(27, 192, 156, 0.4);
  color: #ffffff;
  -webkit-transition: background-color 0.2s ease-out;
  -moz-transition: background-color 0.2s ease-out;
  -o-transition: background-color 0.2s ease-out;
  transition: background-color 0.2s ease-out;
}
</style>
